// extracted by mini-css-extract-plugin
module.exports = {"comp":"Screen4_comp__w7pyC"};